<script>
	import SettingsButton from '../Buttons/SettingsButton.svelte';
	import SoundButton from '../Buttons/SoundButton.svelte';
	import TransparentButton from '../Buttons/TransparentButton.svelte';
	import Coin from '../../../assets/coin.svelte';
	import Timer from '../../../assets/timer.svelte';
	import SettingsPopup from '../Popup/SettingsPopup.svelte';
	import TipsButton from '../Buttons/TipsButton.svelte';
	import BasicInfo from '../Info/BasicInfo.svelte';
	import { onDestroy, onMount } from 'svelte';

	export let noOfCoins = 20;
	export let time = '1432';
	export let themeSupported = false;
	export let theme = {
		themeName: 'Default Theme',
		themeEmoji: '🎁'
	};
	export let isHost = false;
	export let gameNameSvg = '';
	export let isSoundOn = false;
	export let themesHandler = () => {};
	export let soundButtonHandler = () => {};
	export let onMouseDown = () => {};
	export let showRules = false;
	export let showTips = false;
	export let toggleTips = () => {};
	export let isTipsOn = false;
	export let startRoundToolTips5SecondsText = '';
	export let rulesHandler = () => {};
	export let endGameonClick = () => {
		console.log('pressed end game');
	};
	export let endRoundonClick = () => {};

	let showTipsExplain = true;
	let showTipsExplainTimeout;
	onMount(() => {
		if (showTips)
			showTipsExplainTimeout = setTimeout(() => {
				showTipsExplain = false;
			}, 5000);
	});

	onDestroy(() => {
		clearTimeout(showTipsExplainTimeout);
	});
</script>

<div class="headerContainer">
	<div class="innerContainer">
		<div class="left">
			<SoundButton height="30" onClick={soundButtonHandler} {isSoundOn} />
			{#if themeSupported}
				<TransparentButton
					width="96"
					height="30"
					fontSize="15"
					text={theme.themeName}
					emoji={theme.themeEmoji}
					disabled={false}
					onClick={themesHandler}
					{onMouseDown}
				/>
			{/if}
		</div>
		<div class="center">
			<div class="coins">
				<button class="btn btn-coin" style="height: {30}px;fontSize:{18}px;">
					<span class="btnText">
						{noOfCoins}
					</span>
				</button>
				<div class="coins-img-wrapper">
					<Coin />
				</div>
			</div>
			<div class="centerGameNameSvg">
				<img src={`${gameNameSvg}`} alt={gameNameSvg} />
			</div>
			<div class="time">
				<button class="btn" style="height: {30}px;fontSize:{18}px;">
					<span class="btnText">
						{time}
					</span>
				</button>
				<div class="timer-img-wrapper">
					<Timer />
				</div>
			</div>
		</div>
		<div class="right">
			{#if showRules}
				<TransparentButton
					width="87"
					height="30"
					fontSize="16"
					text="Rules"
					emoji="🎲"
					disabled={false}
					onClick={rulesHandler}
					{onMouseDown}
				/>
			{/if}
			{#if showTips}
				<div style="position:relative">
					<TipsButton {toggleTips} {isTipsOn} height="30" {onMouseDown} />
					{#if showTipsExplain && isTipsOn}
						<div style="position:absolute;right:-15px;top:32px">
							<BasicInfo bodyText={startRoundToolTips5SecondsText} fontSize="12" padding="12" />
						</div>
					{/if}
				</div>
			{/if}
			{#if isHost}
				<SettingsButton
					height="30"
					showEndRound={true}
					{endGameonClick}
					{endRoundonClick}
					{onMouseDown}
				/>
			{/if}
		</div>
	</div>
</div>

<style>
	div.headerContainer {
		position: absolute;
		width: 100%;
		height: 100px;
	}
	div.innerContainer {
		display: flex;
		justify-content: space-between;
		position: relative;
		flex-direction: row;
		width: 100%;
		align-items: center;
		padding: 2%;
		margin: auto;
		height: 100%;
	}

	.left,
	.right {
		display: flex;
		justify-content: center;
		align-items: center;
		column-gap: 10px;
	}

	.center {
		position: absolute;
		left: 50%;
		transform: translate(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
		column-gap: 18px;
	}
	.centerGameNameSvg > img {
		width: 142px;
		height: 67px;
	}
	.coins,
	.time {
		position: relative;
		height: 30px;
	}
	.coins-img-wrapper,
	.timer-img-wrapper {
		width: 36px;
		height: 36px;
		position: absolute;
		top: -4px;
	}
	.coins-img-wrapper {
		right: -2px;
	}
	.timer-img-wrapper {
		left: -2px;
	}
	.btn {
		cursor: pointer;
		background-color: transparent;
		border: 2px solid #ffffff;
		border-radius: 18px;
		margin: 0;
		padding: 0;
		display: flex;
		align-items: center;
		padding: 4px;
	}
	.btnText {
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		text-align: left;
		letter-spacing: -0.025em;
		color: #ffffff;
		margin: 0px 1px;
	}
	.coins button {
		padding-left: 8px;
		width: 78px;
		justify-content: flex-start;
		cursor: default;
	}
	.time button {
		padding-right: 8px;
		justify-content: flex-end;
		width: 92px;
		cursor: default;
	}

	@media only screen and (max-width: 750px) {
		.centerGameNameSvg {
			display: none;
		}
	}
	@media only screen and (max-width: 610px) {
		.coins button {
			width: 72px;
		}
		.coins span {
			font-size: 14px;
		}
		.time button {
			width: 82px;
		}
		.time span {
			font-size: 14px;
		}
		.center {
			column-gap: 16px;
		}
	}
</style>
